module.exports = __webpack_public_path__ + "img/reference_03.07ecf88c.jpg";